<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("vouchersPage.tabPending") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <PersonalPendingVouchers v-if="active === 0" />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("vouchersPage.tabExpired") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <PersonalExpiredVouchers v-if="active === 1" />
        </div>
      </v-tab-item>
    </v-tabs>


  </div>
</template>

<script>

import PersonalExpiredVouchers from "@/views/vouchers/personal_vouchers/PersonalExpiredVouchers";
import PersonalPendingVouchers from "@/views/vouchers/personal_vouchers/PersonalPendingVouchers";

export default {
  name: "PersonalVouchers",
  title() {
    return this.$t("vouchersPage.pageTitlePersonal");
  },
  components: {
    PersonalPendingVouchers,
    PersonalExpiredVouchers
  },
  data() {
    return {
      active: 0,
    };
  },

};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
